<div class="bv-security-devices">
  <h1 class="bv-security-page__title">{{ "devices" | i18n }}</h1>
  <p class="bv-security-page__desc">{{ "deviceListDescriptionTemp" | i18n }}</p>

  @if (initializing) {
    <div class="bv-security-devices__loading">
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin tw-text-2xl"
        [ariaLabel]="'loading' | i18n"
      ></bit-icon>
    </div>
  } @else {
    <div class="bv-security-devices-table-wrap">
      <app-web-device-management-table
        class="tw-hidden md:tw-block"
        [devices]="devices"
        [showRecentlyActive]="showRecentlyActive"
        (onAuthRequestAnswered)="handleAuthRequestAnswered($event)"
      ></app-web-device-management-table>
    </div>

    <auth-device-management-item-group
      class="md:tw-hidden bv-security-devices__list"
      [devices]="devices"
      [showRecentlyActive]="showRecentlyActive"
      (onAuthRequestAnswered)="handleAuthRequestAnswered($event)"
    ></auth-device-management-item-group>
  }
</div>
